import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Panel from '../controls/Panel';
import Typography from '@material-ui/core/Typography';
import Button from '../controls/Button';
import ArrowBackIcon from '@material-ui/icons/ChevronLeft';
import ArrowForwardIcon from '@material-ui/icons/ChevronRight';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ActionBar from '../ActionBar';
import StepperPanel from '../StepperPanel/StepperPanel';
import StepDialog from './StepDialog';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ToggleButton from '../controls/SmallButton';
import clsx from 'clsx';
import UnsavedDialog from './../UnsavedDialog';

const drawerWidth = 240;
const styles = (theme) => ({
    root: {
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '15%',
            paddingRight: '15%',
        },
    },
    content: {
        marginTop: theme.spacing(6),
        textAlign: 'center',
    },
    contentSpacer: {
        ...theme.mixins.toolbar,
        marginTop: theme.spacing(3),
    },
    actionBar: {
        marginTop: theme.spacing(6),
        display: 'flex',
        justifyContent: 'center',
    },
    leftActionBar: {
        flexGrow: 1,
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
    },
    drawerSpacer: theme.mixins.toolbar,
    permanentDrawer: {
        padding: theme.spacing(3),
        minWidth: 240,
        maxWidth: `calc(25% - ${theme.spacing(6)}px)`,
        zIndex: theme.zIndex.appBar - 1,
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    grow: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    edit: {
        marginLeft: theme.spacing(0.5),
        padding: theme.spacing(0.5),
    },
    formControl: {
        minWidth: 250,
    },
    dialog: {
        padding: theme.spacing(3),
        alignItems: 'center',
        textAlign: 'center',
    },
    radioGroup: {
        alignItems: 'center',
        textAlign: 'center',
        paddingTop: '5%',
    },
    dialogControl: {
        width: '33%',
        marginLeft: '40%',
    },
    actionButton: {
        marginLeft: 10,
        marginRight: 10,
    },
    text: {
        textAlign: 'center',
    },
    leftCollapseButton: {
        left: drawerWidth - 15,
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftExpandButton: {
        left: theme.spacing(7),
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.up('sm')]: {
            left: theme.spacing(7) + 1,
        },
    },
    leftPanelButton: {
        position: 'absolute',
        top: theme.mixins.toolbar.minHeight * 2,
        '@media (min-width:0px) and (orientation: landscape)': {
            top: theme.mixins.toolbar['@media (min-width:0px) and (orientation: landscape)'].minHeight * 2,
        },
        '@media (min-width:600px)': {
            top: theme.mixins.toolbar['@media (min-width:600px)'].minHeight * 2,
        },
        marginTop: theme.spacing(4),
        zIndex: theme.zIndex.appBar,
    },
    leftDrawerOpen: {
        width: drawerWidth,
        zIndex: theme.zIndex.appBar - 1,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftDrawerClose: {
        zIndex: theme.zIndex.appBar - 1,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),

        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7) + 1,
        },
        padding: theme.spacing(1),
    },
    leftDrawer: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
    },
    leftDrawerContainer: {
        paddingLeft: theme.spacing(3),
    },
});

class FormFinder extends React.Component {
    state = {
        stepDialogOpen: false,
        radio: null,
        question: false,
        isLeftPanelOpen: true,
        openUnsavedDialog: false,
    };

    handleLeftDrawerToggle = () => {
        this.setState((prevState) => ({
            isLeftPanelOpen: !prevState.isLeftPanelOpen,
        }));
    };

    componentDidMount() {
        this.unblock = this.props.history.block(() => {
            if (this.props.unsavedChanges) {
                this.setState({
                    openUnsavedDialog: true,
                });
                return false;
            } else {
                this.handleCloseUnsavedDialog();
                return true;
            }
        });
        if (this.props.match.params.id === 'new') {
            this.props.onLoad();
        } else {
            this.props.onLoad(this.props.match.params.id);
        }
    }

    componentWillUnmount() {
        this.unblock();
        this.props.onUnload();
    }

    handleCloseUnsavedDialog = () => {
        this.setState({
            openUnsavedDialog: false,
        });
    };

    handleStepChange = (step) => {
        this.props.onStepChange(step);
    };

    handleStepsReorder = (steps) => {
        this.props.onStepsReorder(steps);
    };

    handleContinue = () => {
        this.props.onStepChange(this.props.currentStep + 1);
    };

    handleBack = () => {
        this.props.onStepChange(this.props.currentStep - 1);
    };

    handleCreateStep = (event) => {
        this.props.onSectionsChange(this.props.currentStep + 1, this.state.radio);
        this.handleDialogClose(event, 'stepDialogOpen');
        event.preventDefault();
    };

    handleDialogOpen = (dialog) => {
        this.setState({ [dialog]: true });
    };

    handleDialogClose = (event, dialog) => {
        this.setState({ [dialog]: false });
        event.preventDefault();
    };

    handleAddStep = () => {
        this.handleDialogOpen('stepDialogOpen');
    };

    handleRemoveStep = (index) => {
        this.props.onSectionsChange(index);
    };

    handleEditStep = (step) => {
        this.props.onSectionsChange(this.props.currentStep, null, step);
    };

    handleChangeFormFinder = (name) => {
        this.props.onNameChange(name);
    };

    handleChangeRadio = (event) => {
        this.setState({
            radio: event.target.value,
        });
    };

    handleEdit = () => {
        this.props.onEditStep(this.props.steps[this.props.currentStep]);
    };

    render() {
        const adminArea = 'formFinder';
        const currentStep = this.props.currentStep;
        const steps = this.props.steps ? this.props.steps : [];
        const stepperSteps = steps.map((step, index) => `Step ${index + 1}`);
        const isLeftPanelOpen = this.state.isLeftPanelOpen;
        const stepper = (
            <React.Fragment>
                <StepperPanel
                    currStep={currentStep}
                    steps={stepperSteps}
                    sections={steps}
                    handleSectionsReorder={this.handleStepsReorder}
                    handleStepChange={this.handleStepChange}
                    stepType={'Step'}
                    handleAddSection={this.handleAddStep}
                    handleDeleteSection={this.handleRemoveStep}
                    isOpened={this.state.isLeftPanelOpen}
                />
                <Dialog
                    open={this.state.stepDialogOpen}
                    maxWidth="sm"
                    onClose={(event) => this.handleDialogClose(event, 'stepDialogOpen')}
                    fullWidth
                >
                    <form onSubmit={this.handleCreateStep}>
                        <DialogTitle>{'New Step'}</DialogTitle>
                        <DialogContent className={this.props.classes.dialog}>
                            <Typography variant="h6">Select the step type:</Typography>
                            <div className={this.props.classes.radioGroup}>
                                <RadioGroup
                                    className={this.props.classes.dialogControl}
                                    aria-label="stepType"
                                    name="stepType"
                                    value={this.state.radio}
                                    onChange={this.handleChangeRadio}
                                >
                                    <FormControlLabel
                                        value="question"
                                        control={<Radio color="primary" />}
                                        label="Question"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="form"
                                        control={<Radio color="primary" />}
                                        label="Form"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="message"
                                        control={<Radio color="primary" />}
                                        label="Message"
                                        labelPlacement="end"
                                    />
                                </RadioGroup>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={(event) => this.handleDialogClose(event, 'stepDialogOpen')}>Cancel</Button>
                            <Button type="submit">Save</Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </React.Fragment>
        );

        let content = null;
        if (steps.length > 0 && steps[currentStep].choices) {
            content = (
                <div>
                    <Typography className={this.props.classes.text} variant="h6">
                        {steps[currentStep] ? steps[currentStep].text : ''}
                    </Typography>
                    <div className={this.props.classes.content}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel htmlFor="answer">Please select an answer</InputLabel>
                            <Select
                                value={currentStep.choices || ''}
                                onChange={this.handleSelection}
                                inputProps={{ id: 'answer' }}
                            >
                                {(steps[currentStep] ? steps[currentStep].choices : []).map((choice, index) => (
                                    <MenuItem key={index} value={index}>
                                        {choice.choice}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={this.props.classes.actionBar}>
                        <Button className={this.props.classes.actionButton} disabled={true}>
                            Back
                        </Button>
                        <Button variant="contained" disabled={true} className={this.props.classes.actionButton}>
                            Next
                        </Button>
                    </div>
                </div>
            );
        } else if (steps.length > 0 && steps[currentStep].form) {
            content = (
                <div>
                    <Typography variant="h6" className={this.props.classes.text}>
                        {steps[currentStep] ? steps[currentStep].text : ''}
                    </Typography>
                    <div className={this.props.classes.actionBar}>
                        <Button className={this.props.classes.actionButton} disabled={true}>
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            disabled={true}
                            color="primary"
                            className={this.props.classes.actionButton}
                        >
                            Start Application
                        </Button>
                    </div>
                </div>
            );
        } else {
            content = (
                <div>
                    <Typography className={this.props.classes.text} variant="h6">
                        {steps[currentStep] ? steps[currentStep].text : ''}
                    </Typography>
                    <div className={this.props.classes.actionBar}>
                        <Button className={this.props.classes.actionButton} disabled={true}>
                            Back
                        </Button>
                    </div>
                </div>
            );
        }

        return (
            <div className={this.props.classes.root}>
                <UnsavedDialog
                    handleCloseUnsavedDialog={this.handleCloseUnsavedDialog}
                    openUnsavedDialog={this.state.openUnsavedDialog}
                    parent={adminArea}
                />
                <ActionBar
                    parent={adminArea}
                    id={this.props.formFinder.id}
                    name={this.props.formFinder.name}
                    handleEditName={this.handleChangeFormFinder}
                    newName={this.props.match.params.id === 'new'}
                />
                <ToggleButton
                    icon={isLeftPanelOpen ? <ChevronLeftIcon color="primary" /> : <ChevronRightIcon color="primary" />}
                    variant="contained"
                    aria-label={'Stepper Collapse Panel'}
                    onClick={this.handleLeftDrawerToggle}
                    className={clsx(this.props.classes.leftPanelButton, {
                        [this.props.classes.leftCollapseButton]: isLeftPanelOpen,
                        [this.props.classes.leftExpandButton]: !isLeftPanelOpen,
                    })}
                ></ToggleButton>
                <Drawer
                    anchor="left"
                    variant="permanent"
                    className={this.props.classes.leftDrawer}
                    classes={{
                        paper: clsx({
                            [this.props.classes.leftDrawerOpen]: isLeftPanelOpen,
                            [this.props.classes.leftDrawerClose]: !isLeftPanelOpen,
                        }),
                    }}
                >
                    <div>
                        <div className={this.props.classes.drawerSpacer} />
                        <div className={this.props.classes.drawerSpacer} />
                        <div className={this.props.classes.leftDrawerContainer}>{stepper}</div>
                    </div>
                </Drawer>

                <Grid container justifyContent="center" spacing={8} className={this.props.classes.grid}>
                    <Grid item xs={12} md={9} lg={10} xl={8}>
                        <div className={this.props.classes.contentSpacer} />
                        {steps.length < 1 && (
                            <Panel key={'No Questions'}>
                                <div className={this.props.classes.sectionHeader}>
                                    <Typography variant="h6" inline={'true'}>
                                        Add a question to start building form finder
                                    </Typography>
                                </div>
                            </Panel>
                        )}
                        {steps.length > 0 && (
                            <Panel key={'Questions'}>
                                {steps.length > 0 && (
                                    <div>
                                        <div className={this.props.classes.sectionHeader}>
                                            <Typography variant="h5">{`Step ${currentStep + 1}`}</Typography>
                                            <div className={this.props.classes.edit}>
                                                <Tooltip title="Edit Step" enterDelay={200} disableFocusListener={true}>
                                                    <IconButton aria-label="Edit" onClick={this.handleEdit}>
                                                        <Icon color="primary">edit_Icon</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        {content}
                                    </div>
                                )}
                                <div className={this.props.classes.actionBar}>
                                    <div className={this.props.classes.leftActionBar}>
                                        {currentStep > 0 && (
                                            <Button variant="contained" onClick={this.handleBack}>
                                                <ArrowBackIcon className={this.props.leftIcon} />
                                                {'Previous Step'}
                                            </Button>
                                        )}
                                    </div>
                                    <div>
                                        {currentStep < steps.length - 1 && (
                                            <Button variant="contained" onClick={this.handleContinue}>
                                                {'Next Step'}
                                                <ArrowForwardIcon className={this.props.rightIcon} />
                                            </Button>
                                        )}
                                        {currentStep === steps.length - 1 && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => this.handleDialogOpen('stepDialogOpen')}
                                            >
                                                Add New Step
                                            </Button>
                                        )}
                                    </div>
                                </div>

                                {
                                    <StepDialog
                                        forms={this.props.formOptions}
                                        currStep={steps[currentStep]}
                                        handleEditStep={this.handleEditStep}
                                        steps={steps}
                                    />
                                }
                            </Panel>
                        )}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(FormFinder);
